import Footer from "@Components/Footer/Footer";
import "./WhoAreWe.scss";
import Header from "@Components/Header/Header";
import DetailsPageBanner from "@Components/DetailsPageBanner/DetailsPageBanner";
import SvgIcon from "@Components/icons/SvgIcon";
import { Testimonials } from "@Src/features/Home/components/Testimonials/Testimonials";
import Breadcrumb from "@Components/DetailsPageBanner/components/Breadcrumb";
import { MobHeader } from "@Components/Mob-header/Mob-header";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import HelmetComponent from "@Src/utils/helmet/HelmetComponent";

export const WhoAreWe = () => {
  const Headings = [{ name: "About iAbhyas", type: "WHO_ARE_WE" }];
  const navigate = useNavigate();
  const handleStartTest = () => {

    navigate('/testseries/all');

  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

    const helmetProps = [
        {
            tagType: "title",
            content: {
                title: "About iAbhyas | iabhyas"
            }
        },

        {
            tagType: "meta",
            content: {
                name: "description",
                content: "A structured preparation system for JEE, NEET, and competitive exams—designed to turn effort into consistent score improvement."
            }
        },
        {
            tagType: "meta",
            content: {
                name: "keywords",
                content: "about, mock tests, what is iabhyas, practice exams"
            }
        },
        {
            tagType: "meta",
            content: {
                property: "og:title",
                content: "Not Just Practice. Measurable Progress."
            }
        },
        {
            tagType: "meta",
            content: {
                property: "og:description",
                content: "Most platforms give you questions. iAbhyas gives you a system to improve."
            }
        },
        {
            tagType: "meta",
            content: {
                property: "og:url",
                content: "https://www.iabhyas.com/who-are-we"
            }
        },
        {
            tagType: "link",
            content: {
                rel: "canonical",
                href: "https://www.iabhyas.com/who-are-we"
            }
        }
    ]
  return (
    <>
      {/* <HelmetComponent props={helmetProps} /> */}

      <Header />
      <MobHeader />
      <section className="mock-test-listining-container who-are-we-breadcrumb-section">
        <div className="ia-container2" >
          <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-justify-content-between">
            <div className="tw-col-span-2 lg:tw-col-span-1 py-2 px-3 lg:px-6">
              <div className="lg:pt-4">
                <Breadcrumb Headings={Headings} />
              </div>

              <div className="m-t-l-header text-white pt-0 lg:pt-2 ml-0">
                <span className="">
                  Not Just Practice. Measurable Progress.
                </span>
              </div>
              <div className="text-white tw-mt-2">
                A structured preparation system for JEE, NEET, and competitive exams—designed to turn effort into consistent score improvement.

              </div>
              <div className="text-white tw-mt-2">
                Diagnose → Practice → Perform

              </div>
              <div className="pb-4">
                <button className="ia-btn ia-btn-outline-primary tw-bg-white tw-shadow-sm mt-3 hover:border-white" onClick={handleStartTest}>Start Practice<SvgIcon name="rightArrow" size={16} style={{ padding: 0, }} /></button>
              </div>
            </div>
            <div className="tw-col-span-2 lg:tw-col-span-1 pb-0 tw-relative tw-text-right">
              <div className="banneroverlay"></div>
              <img
                src={require("@Assets/img/who-we-are-banner.jpg")}
                alt=""
                className="tw-w-full tw-h-full tw-object-cover tw-relative"
              />
            </div>
          </div>
        </div>
      </section>
      {/* <section >
        <div>
          Why iAbhyas Works
        </div>
        <div>
          Most platforms give you questions. iAbhyas gives you a system to improve.
        </div>
      </section> */}
      {/* <div className="ia-container py-2 lg:py-6">
        <div className="tw-text-center">
          <h2>
            A Trusted Platform for <span>Exam-Focused Learning</span>
          </h2>
          <div className="tw-flex tw-justify-center">
            <div style={{ width: "800px", maxWidth: "100%" }}>
              <p className="tw-px-6">
               iAbhyas is an online mock test platform for competitive exams like JEE, NEET, and other major entrance tests, built to help you prepare the right way.
              </p>
            </div>
          </div>
        </div>
      </div> */}

      <section className="about-us" >
        <div className="tw-text-center py-2 lg:py-6 px-3">
          <h2>Why iAbhyas Works</h2>
          <p className="tw-mt-2">
            Most platforms give you questions. iAbhyas gives you a system to improve.
          </p>
        </div>
        {/* Start About the Founder */}
        <div className="tw-bg-purple-200/30 py-4 lg:py-6 px-3">
          <div className="ia-container" style={{ maxWidth: '1280px' }}>
            <div className="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-center">
              <div className="tw-col-span-12 lg:tw-col-span-4">
                <img
                  src={require("@Assets/img/gl.jpg")}
                  alt=""
                  className="tw-w-full tw-h1-full tw-object-cover tw-rounded-2xl" style={{ maxHeight: '340px' }}
                />
              </div>
              <div className="tw-col-span-12 lg:tw-col-span-8">
                <div className="tw-p-0 lg:tw-px-6">
                  <h2>Built by an IITian. Designed for Results.</h2>
                  <p>iAbhyas was founded by Govind Lal (IIT Kanpur alumnus, former IRS officer) with a clear insight—students don’t lack effort, they lack structure. iAbhyas brings structured system thinking into exam preparation, so every test leads to measurable improvement.</p>
                  <div className="tw-bg-white tw-shadow-lg tw-p-6 tw-rounded-lg tw-border-l-4 tw-border-purple-600 tw-mt-4">
                    <h3 className="tw-text-lg tw-font-semibold tw-text-purple-600">A Note from the Founder</h3>
                    <p className="tw-italic">"Our mission is to bridge the gap between immense effort and actual results. We don't just test you; we train you to perform under pressure."</p>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
        {/* End About the Founder */}
        {/* Start The Performance Engine */}
        <div className="py-4 lg:py-6 px-3">
          <div className="ia-container tw-text-center" style={{ maxWidth: '1280px' }}>
            <h2>The Performance Engine</h2>
            <div className="tw-grid tw-grid-cols-3 tw-gap-4 tw-pt-4 tw-items-center mx-auto">
              <div className="tw-col-span-3 lg:tw-col-span-1 ia-feature-item tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-md ">
                <div className="tw-flex tw-flex-col tw-justify-center w-full gap-3">
                  <div className="tw-flex tw-justify-center">
                    <div className="tw-bg-orange-50 tw-text-orange-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                      <SvgIcon name="timeSpeed" size={26} />
                    </div>
                  </div>

                  <div className="tw-grow1">
                    <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">Diagnose</h3>
                    <p className="tw-text-xs">Identify weak areas</p>
                  </div>
                </div>


              </div>
              <div className="tw-col-span-3 lg:tw-col-span-1 ia-feature-item tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-md ">
                <div className="tw-flex tw-flex-col tw-justify-center w-full gap-3">
                  <div className="tw-flex tw-justify-center">
                    <div className="tw-bg-violet-50 tw-text-violet-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                      <SvgIcon name="bookCap" size={26} />
                    </div>
                  </div>

                  <div className="tw-grow1">
                    <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">Practice</h3>
                    <p className="tw-text-xs">Work on targeted questions</p>
                  </div>
                </div>

              </div>

              <div className="tw-col-span-3 lg:tw-col-span-1 ia-feature-item tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-md ">
                <div className="tw-flex tw-flex-col tw-justify-center w-full gap-3">
                  <div className="tw-flex tw-justify-center">
                    <div className="tw-bg-green-50 tw-text-green-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                      <SvgIcon name="boostConfidence" size={26} />
                    </div>
                  </div>

                  <div className="tw-grow1">
                    <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">Perform</h3>
                    <p className="tw-text-xs">Build exam confidence</p>
                  </div>
                </div>


              </div>

            </div>

          </div>
        </div>
        {/* End The Performance Engine */}

        {/* Start What you Get */}
        <div className="tw-bg-purple-200/30 py-4 lg:py-6 px-3">
          <div className="ia-container" style={{ maxWidth: '1280px' }}>

            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4 tw-items-center mx-auto" >
              <div>
                <h2 className="tw-pb-3">What You Get</h2>
                <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                  <div className="tw-col-span-2 lg:tw-col-span-1 ia-feature-item tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-md ">
                    <div className="tw-flex w-full gap-3">
                      <div className="tw-flex tw-items-start tw-justify-center">
                        <div className="tw-bg-orange-50 tw-text-orange-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                          <SvgIcon name="exanBoard" size={26} />
                        </div>
                      </div>

                      <div className="tw-grow1">
                        <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">Exam-Level Mock Tests</h3>
                        <p className="tw-text-xs">Real pattern. Real difficulty.</p>
                      </div>
                    </div>


                  </div>
                  <div className="tw-col-span-2 lg:tw-col-span-1 ia-feature-item tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-md ">
                    <div className="tw-flex tw-items-start w-full gap-3">
                      <div className="tw-flex tw-items-start tw-justify-center">
                        <div className="tw-bg-violet-50 tw-text-violet-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                          <SvgIcon name="lineChart" size={26} />
                        </div>
                      </div>

                      <div className="tw-grow1">
                        <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">Smart Performance Insights</h3>
                        <p className="tw-text-xs">Know exactly where you lose marks.</p>
                      </div>
                    </div>

                  </div>


                  <div className="tw-col-span-2 lg:tw-col-span-1 ia-feature-item tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-md ">
                    <div className="tw-flex w-full gap-3">
                      <div className="tw-flex tw-items-start tw-justify-center">
                        <div className="tw-bg-blue-50 tw-text-blue-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                          <SvgIcon name="time" size={26} />
                        </div>
                      </div>

                      <div className="tw-grow1">
                        <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">High-Pressure Practice</h3>
                        <p className="tw-text-xs">Build speed and accuracy.</p>
                      </div>
                    </div>


                  </div>
                  <div className="tw-col-span-2 lg:tw-col-span-1 ia-feature-item tw-bg-white tw-p-4 tw-rounded-lg tw-shadow-md ">
                    <div className="tw-flex w-full gap-3">
                      <div className="tw-flex tw-items-start tw-justify-center">
                        <div className="tw-bg-green-50 tw-text-green-500 tw-px-2 tw-py-2 tw-rounded-lg my-2 tw-relative tw-flex tw-item-center">
                          <SvgIcon name="bulb" size={26} />
                        </div>
                      </div>

                      <div className="tw-grow1">
                        <h3 className="tw-text-md tw-font-semibold mb-0 mt-1">Focused Improvement</h3>
                        <p className="tw-text-xs">Turn weak areas into strengths.</p>
                      </div>
                    </div>


                  </div>

                </div>
              </div>
              <div className="lg:tw-pl-4">
                <img
                  src={require("@Assets/img/img-who-we-are.jpg")}
                  alt=""
                  className="tw-w-full tw-h-full tw-object-cover tw-relative tw-rounded-2xl"
                />
              </div>
            </div>


          </div>
        </div>
        {/* End What you Get */}

        {/* Start Highlight */}
        <div className="pt-4 lg:pt-6 px-3 tw-text-center tw-text-2xl tw-font-semibold">
          <div className="tw-text-white py-4 lg:py-6 px-3 tw-text-center mx-auto tw-rounded-xl tw-shadow-2xl" style={{ maxWidth: '1280px', background: 'linear-gradient(135deg, #7F00FF 0%, #7a68e0 100%)' }}>
            <h2 className="tw-text-white">Not a question bank.</h2>
            <p className="tw-text-lg tw-pb-0">A performance training system.</p>
          </div>

        </div>
        {/* End Highlight */}

        {/* Start Final CTA */}
        <div className=" py-4 lg:py-6 px-3 tw-text-center ">
          <h2>Start Preparing the Right Way</h2>
          <p>Practice with structure. Perform with confidence.</p>
          <button className="ia-btn ia-btn-primary tw-shadow-lg mt-3" onClick={handleStartTest}>Start Practice</button>
        </div>
        {/* End Final CTA */}





      </section>

      <Footer />
    </>
  );
};
